import React from 'react'
import Responsive from '../../../components/Responsive';
// import LoaderButton from '../LoaderButton';
// import StagesManager from '../StagesManager';
import { msToHMS, checkTranslation, translate } from "../../../utils/useful";
import moment from "jalali-moment";
import EndQuiz from '../../../components/modals/EndQuiz';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../stores/actionsList';
import HttpServices from '../../../utils/Http.services';
import inputComponents from '../../../components/inputs/inputComponents';
import SocketServices from '../../../utils/socket.services';
import ButtonAnimated from '../../../components/buttons/ButtonAnimated';
// import IntractionActionsList from '../IntractionActionsList';
// import FixedView from '../FixedView';

class Quiz extends React.Component {

    state = {
        quantity: 1,
        answers: {},
        answerSheet: {},
        flags: {},
        currentPage: 0,
        timer: 0,
        leftBar: true
    }

    componentDidMount() {
        this.init()
        // console.log('this.props.quiz?.values', this.props)
        if (!this.props.answerSheetView) {

            if (this.props.quiz?.values?.duration?.length > 0) {
                // let now = new Date()
                let duration = this.props.quiz?.values?.duration
                let seconds = String((Number(duration[0] ?? 0) * 3600) + (Number(duration[1] ?? 0) * 60) + (Number(duration[2] ?? 0) * 1))
                // console.log('secondsbef', seconds)
                if (this.props.current) {
                    // console.log('this.props.current.cDate', this.props.current.cDate)
                    // console.log('now', now)
                    // let diff = now - new Date(this.props.current.cDate).valueOf()
                    // if (diff / 1000 > seconds) {
                    //     seconds = 0
                    // } else {
                    //     seconds = String(Math.floor(seconds - (diff / 1000)))
                    // }
                    // console.log('secondsaf', seconds)
                    // console.log('diff', diff)
                    // console.log('seconds', seconds)
                    // console.log('seconds', new Date(seconds).valueOf())

                    // if(diff)

                }
                //  = this.props.quiz?.values.duration
                // console.log('seconds0', seconds)
                this.setState({ timer: seconds }, () => {

                    this.interval = setInterval(() => {
                        let timer = this.state.timer - 1

                        if (timer < 0) {
                            clearInterval(this.interval)
                            setTimeout(() => {

                                this.props.endInquiry()
                            }, 700);
                        } else {
                            this.setState({ timer }, () => {
                                if (this.props.setHeader) {
                                    this.props.setHeader("dummy", 1)
                                }
                            })
                        }

                    }, 1000)


                    if (this.props.current) {
                        this.time()

                        // let answers = this.props.current.answers ?? {};
                        // this.setState({ answers })

                    }

                });
            }

            if (this.props.setHeader) {

                this.props.setHeader({
                    'topHeaderComponent': this.topHeaderComponent,
                    'showToolbar': false,
                    'title': this.props.page?.title,
                    'subtitle': this.props.page?.subtitle,
                })

            }
        } else {
            if (this.props.setHeader) {

                this.props.setHeader({
                    'topHeaderComponent': this.topHeaderComponentSheet,
                    'showToolbar': false,
                    'title': this.props.page?.title,
                    'subtitle': this.props.page?.subtitle,
                })

            }

        }



    }
    componentDidUpdate() {
    }

    topHeaderComponent = () => {

        return (
            <div className='flexc'>
                {this.showDuration()}

                <ButtonAnimated
                    // iconwidth='24px'
                    onClick={() => { this.EndQuiz.modal.showModal() }}
                    title={translate('End Inquiry')}
                    // icon='/assets/icons/plus-white.svg'
                    textColor={'#000'}
                    // invert={!this.props.colors?.iconInvert}
                    bg={'#fff'}
                // isLoading={this.state.isLoading}
                />
                {/* <button className='py-1 px-3 flexcc' style={{ background: this.props.colors ? this.props.colors.background : "#34C759", borderRadius: 10, color: '#fff', transition: 'all 0.5s' }} onClick={() => this.EndQuiz.modal.showModal()}>
                    <p className='font-size-15'>{translate('End Inquiry')}</p>
                </button> */}
            </div>
        )
    }
    topHeaderComponentSheet = () => {

        return (
            <div className='flexc'>


                <ButtonAnimated
                    // iconwidth='24px'
                    onClick={() => { this.props.endInquirie() }}
                    title={translate('Close AnswerSheet')}
                    // icon='/assets/icons/plus-white.svg'
                    textColor={'#000'}
                    // invert={!this.props.colors?.iconInvert}
                    bg={'#fff'}
                // isLoading={this.state.isLoading}
                />
                {/* <button className='py-1 px-3 flexcc' style={{ background: this.props.colors ? this.props.colors.background : "#34C759", borderRadius: 10, color: '#fff', transition: 'all 0.5s' }} onClick={() => this.EndQuiz.modal.showModal()}>
                    <p className='font-size-15'>{translate('End Inquiry')}</p>
                </button> */}
            </div>
        )
    }



    init = () => {
        // console.log('this.props.current?.question', this.props.current)
        // console.log('this.props.current', this.props.quiz)
        let answers = this.props.current?.values?.answers ?? {}
        let answerSheet = {}
        if (this.props.answerSheetView) {
            answerSheet = this.props.current?.values?.answerSheet
        }
        let flags = this.props.current?.values?.flags ?? {}
        console.log('answers', answers)
        // let question = this.props.current?.question ?? {}
        this.setState({ answers, flags, answerSheet }, () => {

        })




    }
    handleflag = (flag, question) => {
        question.flag = flag
        let flags = this.state.flags
        flags[question.id] = flag
        this.setState({ question, flags }
            , () => {
                this.submitFlag(flag, question.id)
            })
    }

    componentWillUnmount() {
    }

    changeValue = (key, value, extra) => {
        console.log('*changeValue')
        let answers = this.state.answers
        answers[key] = value
        console.log('changevalobject', key, value)
        this.setState({ answers })
        this.sendAnswerToServer(key, value)

    }
    setAnswer = (question, answer, dontSendToServer) => {
        console.log('((setAnswer))')
        let answers = this.state.answers
        if (answers[question.id] == answer) {
            answers[question.id] = null
            // this.setState({ answers }, () => {
            // })
        } else {

            if (!answers) {
                answers = {}
            }
            answers[question.id] = answer

            // this.setState({ answers }, () => {
            // })

        }
        this.setState({ answers }, () => {
            console.log('answersUpdated', this.state.answers)
        })
        // console.log('this.prop.defeffe',this.props)
        if (!dontSendToServer) {
            this.sendAnswerToServer(question.id, answer)
        }

    }

    // startQuiz = () => {
    //     this.props.changeStage('quiz')
    // }

    // endQuiz = () => {
    //     this.props.changeStage('endpage')
    // }

    time = () => {
        // console.log('this.props.quiz?.values1', this.props.quiz?.values)
        const startTime = moment(this.props.current.values?.date);
        const nowTime = moment(new Date());
        let diff = nowTime.diff(startTime)
        let duration = this.props.quiz?.values?.duration
        let time = String((Number(duration[0] ?? 0) * 3600) + (Number(duration[1] ?? 0) * 60) + (Number(duration[2] ?? 0) * 1))
        // let seconds = time
        let seconds = (time) - (diff / 1000)
        if (seconds > 0) {
            this.setState({ timer: seconds })
        } else {
            alert("time is over")
            setTimeout(() => {
                this.props.endInquiry()
                clearInterval(this.interval)
            }, 200)
        }
    }

    changePage = (page) => {
        this.setState({ currentPage: page })
    }

    goToQuestion = (index) => {
        let page = Math.floor(index / (this.state.quantity))
        this.changePage(page)
    }
    sendAnswerToServer(questionId, answer) {
        if (SocketServices.socket?.connected) {
            SocketServices.emit('submitInquiryAnswers', { inquiry: this.props.quiz?._id, question: questionId, answer, applet: this.props.applet._id }, null, (info, err) => {
                if (err) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.submitError', description: err.message })
                }
            })

        }
        // HttpServices.request('submitAnswer', { inquiry: this.props.quiz?._id, question: question.id ?? question._id, answer }, ((fetchResult, fetchError) => {
        //     if (fetchError) {
        //         // this.setAnswer(question, null,true)
        //         this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.submitError', description: fetchError.message })
        //         return
        //     }
        // }))
    }

    submitFlag(flag, question) {
        if (SocketServices.socket?.connected) {
            console.log('question8855', question)
            SocketServices.emit('submitInquiryFlag', { inquiry: this.props.quiz?._id, question: question, status: flag, applet: this.props.applet._id }, null, (info, err) => {
                if (err) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.submitError', description: err.message })
                }
            })

        }

        // console.log('this.propssubmit', this.props)
        // HttpServices.request('submitFlag', { inquiry: this.props.quiz?._id, question: question.id ?? question._id, status: flag }, ((fetchResult, fetchError) => {
        //     if (fetchError) {
        //         this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.submitError', description: fetchError.message })
        //         return
        //     }
        // }))
    }

    handleLeftBar = () => {
        let leftBar = this.state.leftBar
        this.setState({ leftBar: !leftBar })
    }
    // startCounter = () => {
    //     // if (containerRef) return;
    //     setInterval(() => {
    //         this.containerRef.scrollLeft += 62
    //     }, 10);
    // }
    scrollLeft = () => {
        this.containerRef.scrollLeft += 62;
    };

    scrollRight = () => {
        this.containerRef.scrollLeft -= 62;
    };
    showDuration = () => {
        let check = false
        if (Array.isArray(this.props.quiz?.values?.duration)) {
            this.props.quiz?.values?.duration.map((element) => {
                if (element != null && element != '') {
                    check = true
                }
            })
        }
        if (check) {
            // console.log('this.state.timer', this.state.timer)
            return Array.isArray(this.props.quiz?.values?.duration) && this.props.quiz?.values?.duration?.length > 0 ?
                <div className='flexcc flex-column  br-10 h-100 px-3' >
                    <p className='weight-600 white text-small' >{msToHMS(this.state.timer)}</p>
                    <p className='weight-400 font-size-12 white' >{translate('Remaining')}</p>
                </div >
                :
                <div></div>
        }
    }
    render() {
        let quiz = this.state.quiz
        let number = this.state.number
        let startIndex = this.state.currentPage * this.state.quantity
        let totalPages = Math.ceil(this.props.quiz.values.questions.length / this.state.quantity)
        // let question = this.state.questions[0]
        return (

            <div className=" w-100 h-100 " style={{ backgroundColor: 'rgb(229, 229, 234)', }}>
                {/* <div className='d-flex h-100 w-100'> */}
                {/* <div className='w-100 h-100' > */}
                <div className=' h-100' style={{ overflow: 'auto' }}>
                    <div className='w-100' style={{ backgroundColor: '#fff', width: '100%', position: 'sticky', top: 0, borderBottom: '1px solid #f6f6f6' }}>
                        <div className=' w-100 flexcb' >


                            <div className='w-100'>
                                <div className='d-flex w-100 cursor-pointer leftbarQuiz h-100'>
                                    <div className='flexc py-1 w-100 px-2' >
                                        {/* <button onClick={() => { this.scrollRight() }} className='flexcc scroll-button' style={{ rotate: '180deg' }}>
                                                    <img src='/assets/icons/angle-right.svg' width={20} />
                                                </button> */}


                                        <div className='d-flex' >
                                            <div className='mrd-1'>
                                                {/* {this.state.currentPage > 0 && ( */}
                                                <button onClick={() => this.changePage(0)} className='  flexcc' style={{ padding: 6, background: '#eee', borderRadius: 30, color: '#000', transition: 'all 0.5s' }}>
                                                    <img className='rotate-180 invert opacity-2' src='/assets/icons/angle-dright.svg' height={14} />
                                                </button>
                                                {/* )} */}
                                            </div>
                                            <div>
                                                {/* {this.state.currentPage > 0 && ( */}
                                                <button onClick={this.state.currentPage == 0 ? () => { } : () => this.changePage(this.state.currentPage - 1,)} className='  flexcc' style={{ padding: 6, background: '#eee', borderRadius: 30, color: '#000', transition: 'all 0.5s' }}>
                                                    <img className=' opacity-2 rotate-180' src='/assets/icons/angle-right.svg' height={14} />
                                                </button>
                                                {/* )} */}
                                            </div>
                                        </div>


                                        <div ref={ref => this.containerRef = ref} className='flexc w-100 sc-6 px-2' style={{ overflowX: 'scroll' }}>
                                            {this.props.quiz.values.questions.map((item, index) => {
                                                let active = (this.state.currentPage * this.state.quantity) == index
                                                return (
                                                    <div className="flexcc py-1">
                                                        <div className='px-1' style={{ position: 'relative' }}>
                                                            {/* <button onClick={() => this.goToQuestion(index)} className='br-100' style={{ background: this.props.colors ? this.props.colors.secondaryColor : '#eee', opacity: (this.state.currentPage * this.state.quantity) == index ? '1' : '0.5', width: "30px", height: "30px" }}> */}
                                                            {/* rgb(150, 199, 35) */}
                                                            <button onClick={() => this.goToQuestion(index)} className='br-30 px-2' style={{ color: active ? '#fff' : '#00000080', backgroundColor: active ? 'rgb(150, 199, 35)' : '', border: '1px solid #eee', borderColor: active ? 'rgb(150, 199, 35)' : '#ddd', minWidth: "26px", height: "26px" }}>
                                                                <p className='text-bold text-smaller' >{index + 1}</p>
                                                            </button>
                                                            {this.state.flags[item.id] && (
                                                                <button className="p-0 flexcc" style={{ position: 'absolute', top: '2px', left: '1px', pointerEvents: 'none' }} >
                                                                    {/* onClick={() => this.handleflag(false, item)} */}
                                                                    <img className='' width={14} src='/assets/icons/useful/bookmark (1).png' />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            })}


                                        </div>
                                        {/* <button onClick={() => { this.scrollLeft() }} className='flexcc scroll-button'>
                                                    <img src='/assets/icons/angle-right.svg' width={20} />
                                                </button> */}

                                        <div className='flexc' style={{ justifyContent: 'flex-end' }}>
                                            <div className='mrd-1'>
                                                {(this.props.quiz.values.questions?.length - 0.55 >= (this.state.quantity * (this.state.currentPage + 1))) ? (
                                                    <button onClick={this.state.currentPage == (this.props.quiz.values.questions?.length / this.state.quantity) ? () => { } : () => this.changePage(this.state.currentPage + 1)} className='  flexcc' style={{ padding: 6, background: '#eee', borderRadius: 30, color: '#fff', transition: 'all 0.5s' }}>
                                                        <img className=' opacity-2 ' src='/assets/icons/angle-right.svg' height={14} />
                                                    </button>
                                                ) : (
                                                    <button onClick={() => this.EndQuiz.modal.showModal()} className='flexcc' style={{ padding: 6, background: '#eee', borderRadius: 30, color: '#999', transition: 'all 0.5s' }}>
                                                        <span className='text-smaller flexcc mld-3 text-semibold'>Finish</span> <img className=' opacity-2 ' src='/assets/icons/angle-right.svg' height={14} />
                                                    </button>
                                                )}
                                            </div>
                                            <div>
                                                {/* {(this.props.quiz.values.questions?.length - 0.55 >= (this.state.quantity * (this.state.currentPage + 1))) ? ( */}
                                                <button onClick={() => this.changePage(totalPages - 1)} className='  flexcc' style={{ padding: 6, background: '#eee', borderRadius: 30, color: '#fff', transition: 'all 0.5s' }}>
                                                    <img className='invert opacity-2' src='/assets/icons/angle-dright.svg' height={14} />
                                                </button>
                                                {/* ) : (
                                                            <div>
                                                                <button className='py-1 px-3 flexcc' style={{ background: this.props.colors ? this.props.colors.background : "#34C759", borderRadius: 10, color: '#fff', transition: 'all 0.5s' }} onClick={() => this.EndQuiz.modal.showModal()}>
                                                                    <p className='font-size-15'>{translate('End Inquiry')}</p>
                                                                </button>
                                                            </div>
                                                        )} */}
                                            </div>
                                        </div>

                                    </div>
                                </div >
                            </div >
                            {/* {console.log('this.props.quiz?.values?.durationsss',this.props.quiz?.values?.duration)} */}


                        </div >
                    </div>






                    <div className=' flexc flex-column ' >
                        <div className='w-100 h-100 px-4 pt-3 flexc flex-column' style={{ maxWidth: 700 }} >
                            {this.props.quiz.values.questions?.slice(startIndex, (startIndex + this.state.quantity)).map((question, index) => {
                                let correct = false
                                if (this.props.answerSheetView) {
                                    if (this.props.current?.values?.answers[question?.key] == this.props.quiz?.values?.answers[question?.key]) {
                                        correct = true
                                    }
                                }
                                let Component = inputComponents[question.type]
                                let header = question
                                header.information.disabled = false
                                if (this.props.answerSheetView) {
                                    header.information.disabled = true
                                }
                                return (
                                    <div className=' px-2 py-3 my-3 w-100 br-8' style={{ backgroundColor: '#fff', boxShadow: '0px 0px 10px #10101010' }} stage={index}>
                                        <div className='d-flex px-2' style={{ justifyContent: 'space-between' }}>
                                            <div className='px-1'>
                                                <div className='row m-0'>

                                                    <p className='prd-1 font-size-16 text-bold' style={{}}>{translate('Question')} {((this.state.currentPage * this.state.quantity) + index + 1)} / {this.props.quiz.values.questions.length}</p>
                                                    {this.props.answerSheetView && (
                                                        <>
                                                            {correct ? (
                                                                <>
                                                                    <img src='/assets/icons/inquiry/tick.svg' style={{ width: '30px' }} />
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <img src='/assets/icons/inquiry/cancel.svg' style={{ width: '30px' }} />
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                                {/* <p className='font-size-14' style={{ color: '#555' }}></p> */}

                                                {this.props.quiz.values.scores && (
                                                    <div className='d-flex'>
                                                        <p className='prd-2 font-size-12' style={{ color: '#555' }}>{translate('Base Mark')}: {this.props.quiz?.values?.scores[question?.key]}</p>
                                                    </div>
                                                )}
                                            </div>

                                            {!this.props.answerSheetView && (

                                                <div className='flexcc'>
                                                    {this.state.flags[question.id] ? (
                                                        <button className="p-0 flexcc" onClick={() => this.handleflag(false, question)}>
                                                            <img className="" width={16} src="/assets/icons/useful/bookmark (1).png" />
                                                        </button>
                                                    ) : (
                                                        <button className="p-0 flexcc" onClick={() => this.handleflag(true, question)}>
                                                            <img className="" width={16} src="/assets/icons/useful/bookmark.png" />
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>





                                        <div className='p-2 br-10 mt-3'>
                                            <div className='d-flex px-1'>
                                                <p className='font-size-15 weight-500'>{checkTranslation(question?.information.label)}</p>
                                            </div>
                                            {question.type == 'SelectInput' ?
                                                (question.information.items && (question?.information.items.map((answer, i) => {
                                                    let title = 'textTitle' + answer.id
                                                    let value = answer.value ?? answer.id
                                                    return (
                                                        <button disabled={this.props.answerSheetView} className='flexc my-4' style={{}} key={i} onClick={() => { this.setAnswer(question, value) }}>
                                                            <div >
                                                                {(this.state?.answers && (this.state?.answers[question.id] == value)) ? (
                                                                    <div className='flexcc' style={{ width: '26px', height: '26px', border: this.props.colors ? `1px solid ${this.props.colors.secondaryColor}` : '1px solid #34C759', borderRadius: '30px', background: this.props.colors ? this.props.colors.secondaryColor : '#34C759' }}>
                                                                        <p style={{ color: this.props.colors ? this.props.colors.textColor : '#222' }}>{(i + 1)}</p>
                                                                    </div>
                                                                ) : this.state?.answerSheet && (this.state?.answerSheet[question.id] == value) ? (
                                                                    <div className='flexcc' style={{ width: '26px', height: '26px', border: this.props.colors ? `1px solid ${this.props.colors.secondaryColor}` : '1px solid #34C759', borderRadius: '30px', background: '#117722' }}>
                                                                        <p style={{ color: this.props.colors ? this.props.colors.textColor : '#222' }}>{(i + 1)}</p>
                                                                    </div>
                                                                ) : (
                                                                    <div className='flexcc' style={{ width: '26px', height: '26px', border: this.props.colors ? `1px solid ${this.props.colors.secondaryColor}` : '1px solid #34C759', borderRadius: '30px' }}>
                                                                        <p style={{ color: '#222' }}>{(i + 1)}</p>
                                                                    </div>

                                                                )}
                                                            </div>
                                                            <div className='pld-2'>
                                                                <p className='text-start font-size-14'>{checkTranslation(answer['textTitle' + value])}</p>
                                                                <p className='text-start font-size-14'>{checkTranslation(answer.title)}</p>
                                                            </div>
                                                        </button>
                                                    )
                                                }))
                                                ) : (

                                                    <div className='w-100 pt-3'>

                                                        {Component && (
                                                            <div className="w-100 px-3 py-2 br-4" key={question.key} style={{ backgroundColor: '#fff', border: '1px solid #e7e7e7' }}>
                                                                <Component changeValue={this.changeValue} data={(this.props.answerSheetView && this.state.answerSheet) ? this.state.answerSheet[question.key] : this.state.answers[question.key]} ref={el => this["component-" + question.key] = el} header={question} />
                                                            </div>
                                                        )}
                                                    </div>

                                                )}



                                            <div className='flexcb mt-5' style={{}}>
                                                <div className='d-flex' style={{ width: '130px' }}>
                                                    <div className='mrd-3'>
                                                        {/* {this.state.currentPage > 0 && ( */}
                                                        <button onClick={() => this.changePage(0)} className='p-1  flexcc' style={{ background: '#eee', borderRadius: 30, color: '#fff', transition: 'all 0.5s' }}>
                                                            <img className='rotate-180 invert opacity-2' src='/assets/icons/angle-dright.svg' height={18} />
                                                        </button>
                                                        {/* )} */}
                                                    </div>
                                                    <div>
                                                        {/* {this.state.currentPage > 0 && ( */}
                                                        <button onClick={this.state.currentPage == 0 ? () => { } : () => this.changePage(this.state.currentPage - 1,)} className='p-1  flexcc' style={{ background: '#eee', borderRadius: 30, color: '#fff', transition: 'all 0.5s' }}>
                                                            <img className='opacity-2 rotate-180' src='/assets/icons/angle-right.svg' height={18} />
                                                        </button>
                                                        {/* )} */}
                                                    </div>
                                                </div>
                                                <div className='text-smaller'>
                                                    <p> {translate('Page')} {this.state.currentPage + 1} - {totalPages}</p>
                                                </div>
                                                <div className='d-flex' style={{ width: '130px', justifyContent: 'flex-end' }}>
                                                    <div className='mrd-3'>
                                                        {(this.props.quiz.values.questions?.length - 0.55 >= (this.state.quantity * (this.state.currentPage + 1))) ? (
                                                            <button onClick={this.state.currentPage == (this.props.quiz.values.questions?.length / this.state.quantity) ? () => { } : () => this.changePage(this.state.currentPage + 1)} className='p-1 px-2  flexcc' style={{ background: "rgb(150, 199, 35)", borderRadius: 30, color: '#000', transition: 'all 0.5s' }}>
                                                                <p className='white text-bold pld-3'>Next</p>
                                                                <img className=' invert' src='/assets/icons/angle-right.svg' height={18} />
                                                            </button>
                                                        ) : (
                                                            <button onClick={() => this.EndQuiz.modal.showModal()} className='p-1 px-2  flexcc' style={{ background: "rgb(150, 199, 35)", borderRadius: 30, color: '#000', transition: 'all 0.5s' }}>
                                                                <p className='white text-bold pld-3'>Finish</p>
                                                                <img className=' invert' src='/assets/icons/angle-right.svg' height={18} />
                                                            </button>
                                                        )}
                                                    </div>
                                                    <div>
                                                        {/* {(this.props.quiz.values.questions?.length - 0.55 >= (this.state.quantity * (this.state.currentPage + 1))) ? ( */}
                                                        <button onClick={() => this.changePage(totalPages - 1)} className='p-1  flexcc' style={{ background: '#eee', borderRadius: 30, color: '#fff', transition: 'all 0.5s' }}>
                                                            <img className='invert opacity-2' src='/assets/icons/angle-dright.svg' height={18} />

                                                        </button>
                                                        {/* ) : (
                                                            <div>
                                                                <button className='py-1 px-3 flexcc' style={{ background: this.props.colors ? this.props.colors.background : "#34C759", borderRadius: 10, color: '#fff', transition: 'all 0.5s' }} onClick={() => this.EndQuiz.modal.showModal()}>
                                                                    <p className='font-size-15'>{translate('End Inquiry')}</p>
                                                                </button>
                                                            </div>
                                                        )} */}
                                                    </div>
                                                </div>
                                            </div>


                                            {/* {question.type == 'TextInput' &&
                                                            <div>
                                                                TextInput answer
                                                            </div>
                                                        }
                                                        {question.type == 'NumberInput' &&
                                                            <div>
                                                                NumberInput answer
                                                            </div>
                                                        }
                                                        {question.type == 'SelectInput' && question.information.items && (question?.information.items.map((answer, i) => {
                                                            let title = 'textTitle' + answer.id
                                                            return (
                                                                <button className='d-flex my-4' style={{ alignItems: 'flex-start' }} key={i} onClick={() => this.setAnswer(question, answer.id)}>
                                                                    <div >
                                                                        {(this.state?.answers && (this.state?.answers[question.id] != answer.id)) ? (
                                                                            <div className='mt-1' style={{ width: '20px', height: '20px', border: '1px solid #34C759', borderRadius: '2px' }}>
                                                                                <p>{(i + 1)}</p>
                                                                            </div>
                                                                        ) : (
                                                                            <div className='mt-1' style={{ width: '20px', height: '20px', border: '1px solid #34C759', borderRadius: '2px', backgroundColor: '#34C759' }}>
                                                                                <p>{(i + 1)}</p>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <div className='pld-2'>
                                                                        <p className='text-start font-size-14'>{checkTranslation(answer['textTitle' + answer.id])}</p>
                                                                        <p className='text-start font-size-14'>{checkTranslation(answer.title)}</p>
                                                                    </div>
                                                                </button>
                                                            )
                                                        }))}
                                                        {question.type == 'MultiSelectInput' && question.information.test && (question?.information.test.map((answer, i) => {
                                                            let title = 'textTitle' + answer.id
                                                            return (
                                                                <button className='d-flex my-4' style={{ alignItems: 'flex-start' }} key={i} onClick={() => this.setAnswer(question, answer.id)}>
                                                                    <div >
                                                                        {(this.state?.answers && (this.state?.answers[question.id] != answer.id)) ? (
                                                                            <div className='mt-1' style={{ width: '20px', height: '20px', border: '1px solid #34C759', borderRadius: '2px' }}>
                                                                                <p>{(i + 1)}</p>
                                                                            </div>
                                                                        ) : (
                                                                            <div className='mt-1' style={{ width: '20px', height: '20px', border: '1px solid #34C759', borderRadius: '2px', backgroundColor: '#34C759' }}>
                                                                                <p>{(i + 1)}</p>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <div className='pld-2'>
                                                                        <p className='text-start font-size-14'>{checkTranslation(answer['textTitle' + answer.id])}</p>
                                                                        <p className='text-start font-size-14'>{checkTranslation(answer.title)}</p>
                                                                    </div>
                                                                </button>
                                                            )
                                                        }))}
                                                        {question.type == 'LocalSelectInput' && question.information.items && (question?.information.items.map((answer, i) => {
                                                            let title = 'textTitle' + answer.id
                                                            return (
                                                                <button className='d-flex my-4' style={{ alignItems: 'flex-start' }} key={i} onClick={() => this.setAnswer(question, answer.id)}>
                                                                    <div >
                                                                        {(this.state?.answers && (this.state?.answers[question.id] != answer.id)) ? (
                                                                            <div className='mt-1' style={{ width: '20px', height: '20px', border: '1px solid #34C759', borderRadius: '2px' }}>
                                                                                <p>{(i + 1)}</p>
                                                                            </div>
                                                                        ) : (
                                                                            <div className='mt-1' style={{ width: '20px', height: '20px', border: '1px solid #34C759', borderRadius: '2px', backgroundColor: '#34C759' }}>
                                                                                <p>{(i + 1)}</p>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <div className='pld-2'>
                                                                        <p className='text-start font-size-14'>{checkTranslation(answer.title)}</p>
                                                                    </div>
                                                                </button>
                                                            )
                                                        }))}
                                                        {question.type == 'FileInput' &&
                                                            <div>
                                                                FileInput answer
                                                            </div>
                                                        }
                                                        {question.type == 'ImageSelectInput' &&
                                                            <div>
                                                                FileInput answer
                                                            </div>
                                                        }
                                                        {question.type == 'SwitchInput' &&
                                                            <div>
                                                                SwitchInput answer
                                                            </div>
                                                        } */}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    {/* <div className='flexcb py-3' style={{ position: 'sticky', bottom: '0px' }}>
                                <div className='d-flex' style={{ width: '130px' }}>
                                    <div className='mrd-3'>
                                        {this.state.currentPage > 0 && (
                                            <button onClick={() => this.changePage(0)} className='p-1  flexcc' style={{ background: this.props.colors ? this.props.colors.background : "#34C759", borderRadius: 10, color: '#fff', transition: 'all 0.5s' }}>
                                                <div className='flexcc  p-1' style={{ borderRadius: 10 }}>
                                                    <img className='rotate-180' src='/assets/icons/angle-dright.svg' height={18} />
                                                </div>
                                            </button>
                                        )}
                                    </div>
                                    <div>
                                        {this.state.currentPage > 0 && (
                                            <button onClick={this.state.currentPage == 0 ? () => { } : () => this.changePage(this.state.currentPage - 1,)} className='p-1  flexcc' style={{ background: this.props.colors ? this.props.colors.background : "#34C759", borderRadius: 10, color: '#fff', transition: 'all 0.5s' }}>
                                                <div className='flexcc  p-1' style={{ borderRadius: 10 }}>
                                                    <img className='invert rotate-180' src='/assets/icons/angle-right.svg' height={18} />
                                                </div>
                                            </button>
                                        )}
                                    </div>
                                </div>
                                <div className=''>
                                    <p> {translate('Page')} {this.state.currentPage + 1} - {totalPages}</p>
                                </div>
                                <div className='d-flex' style={{ width: '130px', justifyContent: 'flex-end' }}>
                                    <div className='mrd-3'>
                                        {(this.props.quiz.values.questions?.length - 0.55 >= (this.state.quantity * (this.state.currentPage + 1))) ? (
                                            <button onClick={this.state.currentPage == (this.props.quiz.values.questions?.length / this.state.quantity) ? () => { } : () => this.changePage(this.state.currentPage + 1)} className='p-1  flexcc' style={{ background: this.props.colors ? this.props.colors.background : "#34C759", borderRadius: 10, color: '#fff', transition: 'all 0.5s' }}>
                                                <div className='flexcc  p-1' style={{ borderRadius: 10 }}>
                                                    <img className='invert ' src='/assets/icons/angle-right.svg' height={18} />
                                                </div>
                                            </button>
                                        ) : (
                                            <div></div>
                                        )}
                                    </div>
                                    <div>
                                        {(this.props.quiz.values.questions?.length - 0.55 >= (this.state.quantity * (this.state.currentPage + 1))) ? (
                                            <button onClick={() => this.changePage(totalPages - 1)} className='p-1  flexcc' style={{ background: this.props.colors ? this.props.colors.background : "#34C759", borderRadius: 10, color: '#fff', transition: 'all 0.5s' }}>
                                                <div className='flexcc  p-1' style={{ borderRadius: 10 }}>
                                                    <img className='' src='/assets/icons/angle-dright.svg' height={18} />
                                                </div>
                                            </button>
                                        ) : (
                                            <div>
                                                <button className='py-1 px-3 flexcc' style={{ background: this.props.colors ? this.props.colors.background : "#34C759", borderRadius: 10, color: '#fff', transition: 'all 0.5s' }} onClick={() => this.EndQuiz.modal.showModal()}>
                                                    <p className='font-size-15'>{translate('End Inquiry')}</p>
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div> */}
                </div>
                {/* </div> */}
                {/* </Responsive> */}
                {/* </div > */}
                <EndQuiz closeModal={() => this.EndQuiz.modal.hideModal()} ref={el => this.EndQuiz = el} data={this.state?.course} endInquiryModal={() => this.props.endInquiry()} colors={this.props.colors} />
            </div >

        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, cart: state.cart, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Quiz);
